import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {ScheduleService} from "../../_services/schedule.service";

declare var jQuery: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-add-schedule-from-excel',
  templateUrl: './add-schedule-from-excel.component.html',
  styleUrls: ['./add-schedule-from-excel.component.css']
})
export class AddScheduleFromExcelComponent implements OnInit {

  excelData: any[] = [];
  userdetaild: any;
  addScheduleForm: FormGroup;
  submitted = false;
  id: string = this.route.snapshot.params['id'];

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private scheduleservice: ScheduleService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.addScheduleForm = this.formBuilder.group({
      chooseexcel: ['', [Validators.required]],
    });

  }


  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      // this.excelData = JSON.stringify(jsonData);
      this.excelData = jsonData.Sheet1;
      // console.log(this.excelData);

    }
    reader.readAsBinaryString(file);
  }

  get f() { return this.addScheduleForm.controls; };

  addEvent(payload) {
    this.scheduleservice.createMultiSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.router.navigate([`/add-schedule/${this.id}`]);
            this.toaster.showSuccess('Add Schedule', data.ResponseMessage);
          } else {
            this.toaster.showError('Add Schedule', data.ResponseMessage);
            //this.spinnerService.hide();
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Schedule', error.error.ResponseMessage);
          //this.spinnerService.hide();
        });
  }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    if (this.addScheduleForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    let i = 0;

    for (let item of this.excelData) {
      const payload = { 
        docid: this.id,
        day: item.Day,
        date: item.Date,
        start_time: item.StartTime,
        end_time: item.EndTime,
        location: item.Location,
        scheduleFor: item.Available,
        status: item.Status,
        timezone:  Intl.DateTimeFormat().resolvedOptions().timeZone,
        time_offset: new Date().getTimezoneOffset()
      };
      this.addEvent(payload);
      i++;
    }

    if (i > 0 && i == this.excelData.length) {
        this.excelData = [];
    }




  }

}
